const es = {
  "Home.taskName": "Nombre de la tarea",
  "Home.addNewTask": "Agregar Tarea",
  "Home.noTask": "No tienes niguna tarea aún. Agrega una nueva",
  "Nav.deleteAllTask": "Eliminar todas las tareas",
};

export default es;
